module.exports.assign = function(target) {
  if (Object.assign) {
    return Object.assign.apply(null, arguments);
  }

  if (target == null) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  target = Object(target);
  for (var index = 1; index < arguments.length; index++) {
    var source = arguments[index];
    if (source != null) {
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
  }
  return target;
};



//////////////////
// WEBPACK FOOTER
// ./lib/object.js
// module id = 11
// module chunks = 1 3